import React, {useState} from 'react'
import Col from 'react-bootstrap/Col'
import Button from 'react-bootstrap/Button'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import Count from '../../../ui/page/Count'
import useFetch from '../../../../hooks/useFetch'
import OuverturesAPI from '../../../../services/OuverturesAPI'
import {ExceptionalOpeningsContentTab} from './ExceptionalOpeningsContentTab'
import {ExceptionalOpeningsForm} from './ExceptionalOpeningsForm'

export const ExceptionalOpenings = () => {
    const [showAddExceptionalOpenings, setShowAddExceptionalOpenings] = useState(false);
    const [{data: exceptionalOpenings, totalItems, isLoading, isError}, fetchData] = useFetch(OuverturesAPI.getOuvertures());

    return (
        <>
            <Col>
                <div className={'bg-light p-3 d-flex align-items-center border-left border-right border-top'}>
                    <Col className={'my-auto bg-white'}>
                        <h3>Ouvertures exceptionnelles</h3>
                    </Col>
                    <Col className={'my-auto d-lg-flex justify-content-end'}>
                        <Button
                            onClick={() => setShowAddExceptionalOpenings(true)}
                            variant={'primary'}
                            className={'mr-3'}
                        >
                            <FontAwesomeIcon
                                icon="plus-circle"
                                color="white"
                                className="mr-2"
                            />
                            Ajouter
                        </Button>
                        <Count totalItems={totalItems} name={'ouverture'} classNames={'my-auto'}/>
                    </Col>
                </div>
                <hr className="m-0"/>
                <ExceptionalOpeningsContentTab exceptionalOpenings={exceptionalOpenings} isLoading={isLoading} fetchData={fetchData} isError={isError}/>

                <ExceptionalOpeningsForm show={showAddExceptionalOpenings} onHide={() => setShowAddExceptionalOpenings(false)} fetchData={fetchData} />
            </Col>
        </>
    );
}
